<template>
    <CRow>
        <CDataTable
            class="col-12 px-0"
            :items="Object.values(links)"
            :fields="$dataTableFieldsMaker(fields)"
            hover
            :pagination="{ ...pagination, change: fetchLinks }"
            addTableClasses="bg-white"
        >
            <template #title="{ item }">
                <td>
                    {{ item.title }}
                    <span
                        v-if="item.is_parent"
                        class="badge badge-affili-eggplant"
                    >{{ $t('link.parent') }}</span>
                </td>
            </template>

            <template #store="{ item }">
                <td dir="ltr">{{ item.store.name }}</td>
            </template>

            <!-- <template #orgLink="{ item }">
                <td v-if="item.type === LinkType.DEVELOPER" class="text-center">
                    <span class="badge badge-info p-2">{{ $t('link.types.developer') }}</span>
                </td>
                <td dir="ltr" class="text-center" v-else>
                    <CLink :href="item.href" target="_blank">
                        <FaIcon icon="link" />
                    </CLink>
                </td>
            </template> -->

            <template #shortedLink="{ item }">
                <td class="text-center" v-if="!item.page_builder_id">
                    <CLink v-clipboard:copy="item.shorted_link" v-clipboard:success="onCopy">
                        <FaIcon icon="copy" class="text-info" />
                    </CLink>
                    <CLink class="mfs-2" :href="item.shorted_link" target="_blank">
                        <FaIcon icon="link" />
                    </CLink>
                </td>
                <td class="text-center" v-else>
                    <span class="badge badge-secondary p-2">{{ $t('pageBuilder.page') }}</span>
                </td>
            </template>

            <template #clicks="{ item }">
                <td class="text-center">{{ item.clicks }} / {{ item.today_clicks }}</td>
            </template>

            <template #user="{ item }">
                <td>{{ item.user ? item.user.full_name : '---' }}</td>
            </template>

            <template #createdAt="{ item }">
                <td dir="ltr">{{ $moment(item.created_at).format('jYYYY/jMM/jDD') }}</td>
            </template>

            <template #status="{ item }">
                <td>
                    <span :class="'badge badge-' + statusColor(item)">{{ statusStr(item) }}</span>
                </td>
            </template>

            <template #actions="{ item }">
                <td v-if="!item.page_builder_id">
                    <CLink
                        :disabled="item.status !== LinkStatus.ACTIVE"
                        @click="editModal = { item: item, show: true }"
                    >
                        <FaIcon
                            icon="edit"
                            :class="item.status === LinkStatus.ACTIVE ? 'text-behance' : 'text-dark'"
                        />
                    </CLink>
                    <CLink
                        class="mfs-1"
                        @click="modal = { show: true, item: item }"
                        v-if="$policy('link', item).soft_delete"
                    >
                        <FaIcon icon="trash" class="text-danger" />
                    </CLink>
                </td>
                <td v-else>-</td>
            </template>
        </CDataTable>
        <CModal :title="$t('link.delete')" color="danger" :show.sync="modal.show">
            {{ $t('link.are_you_sure_to_remove', { attribute: modal.item.title }) }}
            <template
                #footer
            >
                <CButton @click="modal.show = false" color="secondary">{{ $t('cancel') }}</CButton>
                <CButton @click="deleteModal" color="danger">{{ $t('delete') }}</CButton>
            </template>
        </CModal>
        <CModal :show.sync="editModal.show">
            <template #header-wrapper>
                <div></div>
            </template>

            <Form :submit="submit" :link="editModal.item" ref="linkForm" class="px-1 pt-3" />

            <template #footer-wrapper>
                <div></div>
            </template>
        </CModal>
    </CRow>
</template>

<script>
import Form from './Form'
import fields from './fields'
import { LinkStatus, LinkType } from '@/constants'
import { mapGetters, mapActions } from 'vuex'
import { statusStr, statusColor } from './methods'

export default {
    name: 'List',

    components: {
        Form
    },

    data() {
        return {
            LinkStatus,
            LinkType,
            fields,
            modal: {
                show: false,
                item: {},
            },
            editModal: {
                show: false,
                item: {},
            }
        }
    },

    computed: {
        ...mapGetters({
            links: 'link/links',
            pagination: 'link/pagination',
            filterMeFields: 'filterMeComponent/filterMeFields',
        }),
    },

    watch: {
        'editModal.show'() {
            this.resetMsg()
        }
    },

    methods: {
        statusStr,
        statusColor,
        ...mapActions({
            fetch: 'link/fetch',
            deleteLink: 'link/delete',
            edit: 'link/edit',
            setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
            setShowLoading: 'loadingComponent/setShowLoading',
        }),
        ...mapActions('toastComponent', [
            'setCToast',
        ]),
        fetchLinks(activePage, params = false) {
            this.fetch({
                page: activePage,
                ...params,
                ...this.filterMeFields
            })

            this.pagination.page = activePage
        },
        onCopy() {
            this.setCToast({
                msg: this.$t('link.affiliate_link_copied'),
                class: 'text-white font-weight-bold bg-success'
            })
        },
        deleteModal() {
            this.deleteLink(this.modal.item.id).then(() => this.modal.show = false)
        },
        submit() {
            const linkForm = this.$refs.linkForm
            this.setShowLoading()
            this.resetMsg()

            this.edit(this.editModal.item).then(() => {
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.updateLink'),
                    type: 'success'
                })
            }).catch(result => {
                if (result.data) {
                    linkForm.$refs.form.setErrors(result.data);
                }
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.' + result.tag),
                    type: 'danger'
                })
            })
        },
    },
}
</script>